export default __webpack_public_path__ + "static/media/work-with-a-coach.7f6d75f1.svg";